const filterArrays = {
    'Flat Turf': ['F'],
    'All-weather': ['X'],
    NHF: ['B', 'W'],
    Hurdle: ['H', 'Y'],
    Chase: ['C', 'U', 'Z'],
    PTP: ['P'],
};

const findTypeByCode = code => Object.keys(filterArrays)
    .filter(type => filterArrays[type].includes(code))[0];

export {
    filterArrays as default,
    findTypeByCode,
};



// WEBPACK FOOTER //
// ./src/js/horse/form/filterArrays.js